import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useHistory } from "react-router-dom";

// styles
import styles from "./Header.module.scss";

// icons
import { IoNotifications } from "react-icons/io5";
import { MdOutlineCancel } from "react-icons/md";
import { auth, db } from "../../firebase";
import { notificationService } from "../../Services/notification-service";

export const NotificationMenu = ({ show, handleClose, setHasUnreadNotifications }) => {
  const [notifications, setNotifications] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const unsubscribe = db
      .collection('notifications')
      .where('receipients', 'array-contains', auth.currentUser.uid)
      .onSnapshot(snapshot => {
        const unreadNotifications = snapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(doc => !doc.read[auth.currentUser.uid])
          .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

        setNotifications(unreadNotifications);
        setHasUnreadNotifications(unreadNotifications.length > 0);
      });
  
    return () => unsubscribe();
  }, []);
  
  

  const handleMarkAsRead = (notificationId) => {
    notificationService.markAsRead(notificationId, auth.currentUser.uid);
  }

  const handleNotificationClick = (notification) => {
    if (notification.playerId) {
      history.push(`/player-profile/preview/${notification.playerId}`);
      handleClose();
    }
  }

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className={styles.notificationsSections}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className={styles.title}>
              <IoNotifications className="mr-2" />
              <span>Notifications</span>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className={styles.listgroup}>
           {notifications.map(notification => {
            return (
              <ListItem
                key={notification.id}
                item={notification}
                handleMarkAsRead={handleMarkAsRead}
                handleNotificationClick={handleNotificationClick}
              />
            )
           })} 
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

const ListItem = ({ item, handleMarkAsRead, handleNotificationClick }) => {
  return (
    <div 
      className={styles.listItem}
      onClick={() => handleNotificationClick(item)}
      style={{ cursor: item.playerId ? 'pointer' : 'default' }}
    >
      <div>
        <h4>{item.message}</h4>
        <p>{new Date(item.timestamp).toDateString()}</p>
      </div>
      <div>
        <MdOutlineCancel 
          onClick={(e) => {
            e.stopPropagation();
            handleMarkAsRead(item.id);
          }}
        />
      </div>
    </div>
  );
};
